/**
 * Interruptores de módulos que están en el sistema pero no se usan.
 * Apagar acá oculta la entrada del menú, la ruta y los accesos secundarios,
 * sin borrar nada: volver a poner `true` lo reactiva tal como estaba.
 */

// Chat de WhatsApp (bandeja del negocio + panel por cliente).
// Apagado el 29/07/2026 por decisión de Rodrigo: no se usa (la atención va por
// el WhatsApp del celular). El backend sigue intacto: los templates de turnos,
// remitos, presupuestos, diagnósticos y reseñas se envían igual.
export const WHATSAPP_CHAT_ENABLED = false;
